export const production = true;

export const environment = {
  production,
  APP_ID: 'careapp-web-prod',
  APP_VERSION: '1.0.0',
  API_V2_BASE_PATH: 'https://api.careapp.com.au',
  API_BASE_URL: 'https://api.careapp.com.au',
  APP_BASE_URL: 'https://app.careapp.com.au/#',
  API_VERSION: 'api/v1',
  GOOGLE_MAPS_API_KEY: 'AIzaSyBWvmTl7YRL30d-qrmKMuEPSbXssz6RHU8',
  ROLLBAR_ACCESS_TOKEN: '76c70f6830b546878a9576567872d0aa',
  ROLLBAR_ENV_NAME: 'PRODUCTION',
  STATS_TABLE_LIMIT: 5,
  httpTimeout: 10000,
  chatPollInterval: 30000,
  notificationsPollInterval: 60000,
  streamApiKey: '3xab2y6mqyh4',
  kratosFrontendUrl: 'https://accounts.careapp.com.au',
  useKratos: true,

  fileDownloadMode: 'get',

  maxVideoUploadLengthS: 300,

  announcements: {
    shareToFamilyRepresentatives: true,
  },
  documents: {
    shareToFamilyRepresentatives: true,
  },
  questions: {
    shareToFamilyRepresentatives: true,
  },

  stripe: {
    publicKey:
      'pk_live_51NaV3oKYjY3VzQOjAmIvQaBT2tosC3mu87dVwarvxyVSL7JCZEolc1xpWQk6bTtY6uRqtVRtbYOxsoSv6RutZxuf00Thj5jEVE',
  },

  /**
   * TTL for cached objects in the store, in milliseconds
   */
  cacheTime: 1 * 60 * 60 * 1000,

  memoriam: {
    resourcesBaseUrl:
      'https://careapp-video-transcoding-memoriamresourcesbucket-8hgpcgh3tz7r.s3-ap-southeast-2.amazonaws.com',
  },

  releaseNotes: {
    feedUrl: 'https://www.careapp.com.au/category/release-notes/feed/',
  },

  firebase: {
    apiKey: 'AIzaSyBwDIVadU5AdoJ35f2fumi0gW2OEN6GJIA',
    authDomain: 'careapp-32941.firebaseapp.com',
    databaseURL: 'https://careapp-32941.firebaseio.com',
    projectId: 'careapp-32941',
    storageBucket: 'careapp-32941.appspot.com',
    messagingSenderId: '136981136015',
    appId: '1:136981136015:web:64b2be87378e59d62ba6fa',
    measurementId: 'G-M1QCTM64X9',
    remoteConfig: {
      memoriam_music_options: [],
      show_config_list: false,
      web_configure_2fa: true,
      preferred_countries: [],
      web_phone_based_password_reset: false,
      web_provider_customer_management: true,
      web_set_email: true,
      web_family_representative: true,
      web_member_management: true,
      web_provider_notice_management: true,
      web_integrations: false,
      web_member_badges: true,
      web_wrapped_enabled: false,
      wrapped_year: '2024',
      web_sensitive_memos: false,
    },
  },
};
